import React from 'react';

export const Layout = ({ children }) => {
  return <main>{children}</main>;
};
